"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AcButton_1 = require("../../button/AcButton");
var AcPdfEditorSideMenu_1 = require("../AcPdfEditorSideMenu");
exports.AcPdfSetPhraseSaveButtons = function (_a) {
    var onClickSave = _a.onClickSave, onClickCancel = _a.onClickCancel, loading = _a.loading, error = _a.error;
    var setActiveMenu = react_1.useContext(AcPdfEditorSideMenu_1.AcPdfEditorSideMenuContext).setActiveMenu;
    var onCancel = function () {
        onClickCancel();
        if (setActiveMenu) {
            setActiveMenu('phraseMenu');
        }
    };
    var onSave = function () {
        onClickSave();
        if (setActiveMenu) {
            setActiveMenu('phraseMenu');
        }
    };
    return (react_1.default.createElement("div", { className: "row w-auto" },
        react_1.default.createElement("div", { className: "col-md-6" },
            react_1.default.createElement(AcButton_1.AcButton, { block: true, size: "lg", className: "px-2", variant: "outline-apzlinkblue", onClick: onCancel }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
        react_1.default.createElement("div", { className: "col-md-6" },
            react_1.default.createElement(AcButton_1.AcButton, { block: true, size: "lg", className: "px-2", disabled: loading || error, variant: "apzlinkblue", onClick: onSave }, "\u7DE8\u96C6\u7D42\u4E86"))));
};
exports.AcPdfSetPhraseSaveButtons.displayName = 'AcPdfSetPhraseSaveButtons';
//# sourceMappingURL=AcPdfSetPhraseSaveButtons.js.map